'use client';
import React from 'react';
import { Zap, CheckCircle, ShieldCheck, Briefcase } from 'lucide-react';

export interface PackageTier {
  name: string;
  price: string;
  renewal?: string;
  description: string;
  features: string[];
  icon: React.ReactNode;
  discountNote?: string;
  ctaText?: string;
  ctaLink?: string;
  onClick?: () => void;
}

export const packageTiers: PackageTier[] = [
  {
    name: 'Starter Analysis',
    price: 'Free Consultation',
    renewal: 'Get your personalized quote',
    description: 'Discover exactly what\'s blocking your conversions with our comprehensive analysis.',
    features: ['Complete Website Analysis', 'Conversion Blocker Identification', 'Personalized Action Plan', 'ROI Projection Report'],
    icon: <Zap className="h-8 w-8 text-primary" />,
    ctaText: 'Get My Free Analysis',
    onClick: () => {
      const badge = document.querySelector('.calendly-badge-content');
      if (badge) {
        (badge as HTMLElement).click();
      }
    }
  },
  {
    name: 'Growth Accelerator',
    price: 'Custom Quote',
    renewal: 'Based on your specific needs',
    description: 'Transform your website into a lead-generating machine with proven optimization strategies.',
    features: ['Everything in Starter Analysis', 'Priority Issue Resolution', 'Conversion Rate Optimization', 'Performance Monitoring', '3x More Leads Guarantee'],
    icon: <CheckCircle className="h-8 w-8 text-primary" />,
    ctaText: 'Scale My Business',
    onClick: () => {
      const badge = document.querySelector('.calendly-badge-content');
      if (badge) {
        (badge as HTMLElement).click();
      }
    }
  },
  {
    name: 'Enterprise Domination',
    price: 'Premium Investment',
    renewal: 'ROI-focused pricing',
    description: 'Complete digital transformation for high-traffic websites ready to dominate their market.',
    features: ['Everything in Growth Accelerator', 'Dedicated Success Manager', 'Advanced Analytics Dashboard', 'Continuous Optimization', 'White-Glove Service'],
    icon: <ShieldCheck className="h-8 w-8 text-primary" />,
    discountNote: 'Guaranteed 300% ROI or money back',
    ctaText: 'Dominate My Market',
    onClick: () => {
      const badge = document.querySelector('.calendly-badge-content');
      if (badge) {
        (badge as HTMLElement).click();
      }
    }
  },
  {
    name: 'Custom Solution',
    price: "Let's Discuss",
    description: 'Tailored strategies for unique challenges and enterprise-level requirements.',
    features: ['Personalized Strategy Session', 'Custom Implementation Plan', 'Dedicated Expert Team', 'Unlimited Revisions'],
    icon: <Briefcase className="h-8 w-8 text-primary" />,
    ctaText: 'Build My Strategy',
    onClick: () => {
      const badge = document.querySelector('.calendly-badge-content');
      if (badge) {
        (badge as HTMLElement).click();
      }
    }
  },
];
